const { default: axios } = require("axios");

const SicknessWizard = function () {

    let _wizardEl;
    let _wizard;

    const initWizard = function () {
        _wizard = new KTWizard(_wizardEl, {
            startStep: 1,
            clickableSteps: true
        });

        _wizard.on('beforeNext', function (wizard) {
            sicknessResume();

            if (_wizard.getStep() == 1) {
                _wizard.stop();
            }

            if (_wizard.getStep() == 2) {
                _wizard.stop();

                const element = $('#current_sickness_id');
                axios({
                    method: 'get',
                    url: element.data('url'),
                    params: {
                        id: element.val()
                    }
                }).then(function (response) {
                    const data = response.data;

                    if (data.error == false) {
                        const result = data.result;
                        if (result.symptoms.length == 0) {

                            Swal.fire({
                                text: "A doença não possui sintomas cadastrados",
                                icon: "error",
                                buttonsStyling: false,
                                confirmButtonText: "Ok",
                                customClass: {
                                    confirmButton: "btn font-weight-bold btn-light"
                                }
                            });

                        } else {
                            _wizard.goNext();
                        }
                    }
                });


            }

            if (_wizard.getStep() == 3) {
                $('.btn-wizard-footer').hide();
            }
        });

        _wizard.on('change', function (wizard) {
            KTUtil.scrollTop();
        });
    }

    const callbackAutocomplete = function () {
        const item = $(this);
        const value = item.val();
        const urlCallback = item.data('urlcallback');

        $("#formSymptom").find('input, textarea').attr('readonly', 'readonly');
        $("#formSymptom").find('input.sickness-symptom, textarea.sickness-symptom').removeAttr('readonly');

        axios({
            method: 'get',
            url: urlCallback,
            params: {
                id: value
            }
        }).then(function (response) {
            const data = response.data;

            if (data.error === false) {
                const result = data.result;

                Object.keys(result).forEach(key => {
                    $('div[data-wizard-state="current"]').find('.callbackAutocomplete input[name="' + key + '"]').val(result[key]);
                    $('div[data-wizard-state="current"]').find('.callbackAutocomplete textarea[name="' + key + '"]').val(result[key]);
                });

                if (_wizard.getStep() == 1) {
                    $('#current_sickness_id').val(result.id);
                    sicknessResume();
                }
            }

            if (_wizard.getStep() == 2 && value == 0) {
                $("#formSymptom .fields-form").find('input, textarea').removeAttr('readonly');
                $("#formSymptom .fields-form").find('input, textarea').val("");
            }
            
            if (_wizard.getStep() == 1 && value == 0) {
                $("#formSickness .fields-form").find('input, textarea').val("");
            }


            $('div[data-wizard-state="current"]').find('.form-callbackAutocomplete').slideDown();
        });
    }

    const actionNext = function () {
        const step = $('div[data-wizard-type="step-content"][data-wizard-state="current"]');
        const form = step.find('.form-callbackAutocomplete');

        form.trigger('submit');
    }

    const submitForm = function (e) {
        e.preventDefault();

        const element = $(this);

        axios({
            method: 'post',
            url: element.attr('action'),
            data: element.serialize()
        }).then(function (response) {
            const data = response.data;

            if (data.error) {
                Swal.fire({
                    text: data.message,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Ok",
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-light"
                    }
                });
            } else {
                if (_wizard.getStep() == 1) {
                    $('div[data-wizard-state="current"] .callbackAutocomplete #id').val(data.result.id);
                    $('#current_sickness_id').val(data.result.id);
                    _wizard.goNext();
                }

                if (_wizard.getStep() == 2) {
                    $('div[data-wizard-state="current"]').find('.form-callbackAutocomplete').slideUp();
                    $("#formSymptom .fields-form").find('input, textarea').val("");
                }

                sicknessResume();
            }
        });
    }

    const sicknessResume = function () {
        const element = $('#current_sickness_id');

        const sickness_id = element.val();
        const url = element.data('url');

        axios({
            method: 'get',
            url: url,
            params: {
                id: sickness_id,
                resume: 1
            }
        }).then(function (response) {
            const data = response.data;

            if (data.error == false) {
                const result = data.result;

                if (result.html) {
                    $(".sickness-resume").html(result.html);
                    $(".sickness-resume.no_action").html(result.html_no_action);
                }
            }
        });
    }

    const wizardEditSymptom = function (e) {
        e.preventDefault();

        const element = $(this);
        const href = element.attr('href');

        axios({
            method: "get",
            url: href
        }).then(function (response) {
            const data = response.data;

            if (data.error === false) {
                const result = data.result;
                const symptom = result.symptoms[0];

                Object.keys(symptom).forEach(key => {
                    $('.callbackAutocomplete input[name="' + key + '"]').val(symptom[key]);
                    $('.callbackAutocomplete textarea[name="' + key + '"]').val(symptom[key]);
                });

                $(".callbackAutocomplete #points").val(symptom.pivot.points);
                $(".callbackAutocomplete #description_sickness_symptom").val(symptom.pivot.description_sickness_symptom);

                $('div[data-wizard-state="current"]').find('.form-callbackAutocomplete').slideDown();
            }
        });
    }

    return {
        init: function () {
            if ($('#kt_wizard_v3').length == 0) {
                return false;
            }

            _wizardEl = KTUtil.getById('kt_wizard_v3');
            initWizard();

            $(document).on('change', 'select.callbackAutocomplete', callbackAutocomplete);
            $(document).on('click', 'button[data-wizard-type="action-next"]', actionNext);
            $(document).on('submit', '.form-callbackAutocomplete', submitForm);
            $(document).on('click', '.wizard-edit-symptom', wizardEditSymptom);
        }
    }
}();

module.exports = SicknessWizard;